import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import About from "@/components/About";
import Vision from "@/components/Vision";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import WhyUs from "@/components/WhyUs";
import Gallery from "@/components/Gallery";
import CtaBand from "@/components/CtaBand";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ServiceDetail from "@/components/ServiceDetail";

const Home = () => {
  const { hash } = useLocation();
  const lenis = useLenis();

  useEffect(() => {
    document.title = "CV Trinita Bahana Persada — Marine Supply & Maritime Support";
    const meta = document.querySelector('meta[name="description"]');
    if (meta)
      meta.setAttribute(
        "content",
        "CV Trinita Bahana Persada — Ship Chandler, Working Gear & PPE Supply, Crew Documentation Services, dan Visa & Embassy Services. Mitra terpercaya industri maritim Indonesia sejak 2014."
      );
  }, []);

  useEffect(() => {
    if (!hash) return;
    const timer = setTimeout(() => {
      if (lenis) lenis.scrollTo(hash, { offset: -70, duration: 1.0 });
      else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
    }, 150);
    return () => clearTimeout(timer);
  }, [hash, lenis]);

  return (
    <main>
      <Hero />
      <EditorialMarquee />
      <About />
      <Vision />
      <Services />
      <Industries />
      <WhyUs />
      <Gallery />
      <CtaBand />
    </main>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2 }}>
        <BrowserRouter>
          <div className="min-h-screen bg-white font-body text-ink">
            <Navbar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
            <WhatsAppFloat />
            <Toaster position="top-center" richColors />
          </div>
        </BrowserRouter>
      </ReactLenis>
    </LanguageProvider>
  );
}

export default App;
